// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__h3U63","content":"styles_content__LZ9fI","row":"styles_row__-zher","footer":"styles_footer__1ou40","phraseLength":"styles_phraseLength__2Q5aW"};